import { useEffect, useState } from 'react';
import { fetchUsers, fetchDropdownsInformation } from 'Api/courseDetailsMembers';

const useFetch = (courseId, setIsLoading) => {
  const [users, setUsers] = useState([]);
  const [department, setDepartment] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [jobTitle, setJobTitle] = useState(null);
  const [jobTitles, setJobTitles] = useState([]);
  const [terminal, setTerminal] = useState(null);
  const [terminals, setTerminals] = useState([]);
  const [fullName, setFullName] = useState(null);

  useEffect(() => {
    const newDepartment = department === '' ? null : department;
    const newJobTitle = jobTitle === '' ? null : jobTitle;
    const newTerminal = terminal === '' ? null : terminal;
    let isMounted = true;

    if (isMounted) {
      fetchUsers({
        courseId,
        department: newDepartment,
        jobTitle: newJobTitle,
        terminal: newTerminal,
        fullName,
      }).then(data => {
        setUsers(data.users);
        setIsLoading(false);
      });
    }

    return () => {
      isMounted = false;
      setUsers([]);
    };
  }, [courseId, department, jobTitle, terminal, fullName]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchDropdownsInformation().then(data => {
        setDepartments(data.departments);
        setJobTitles(data.jobTitles);
        setTerminals(data.terminals);
      });
    }

    return () => {
      isMounted = false;
      setDepartments([]);
      setJobTitles([]);
      setTerminals([]);
    };
  }, []);

  return {
    users,
    departments,
    jobTitles,
    terminals,
    setUsers,
    setDepartment,
    setJobTitle,
    setTerminal,
    setFullName,
  };
};

export default useFetch;
